/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppAliases {
  ACCOUNT_ACTIVATION = 'account-activation',
  ACCOUNT_ACTIVATION_FRAGMENT = 'account-activation-fragment',
  ACCOUNT_REACTIVATION = 'account-reactivation',
  ACCOUNT_REACTIVATION_FRAGMENT = 'account-reactivation-fragment',
  ASSIGN_PRIVACY_FRAGMENT = 'assign-privacy-fragment',
  ASSIGN_PRIVACY_ROUTE = 'assign-privacy-route',
  ASSIGN_TERMS_FRAGMENT = 'assign-terms-fragment',
  ASSIGN_TERMS_ROUTE = 'assign-terms-route',
  BUTTON_INCREMENT_COUNTER = 'button-increment-counter',
  BUTTON_SHOW_COUNTER = 'button-show-counter',
  CHANGE_PASSWORD_FRAGMENT = 'change-password-fragment',
  CHANGE_PASSWORD_ROUTE = 'change-password-route',
  CONTENT_PANEL = 'content-panel',
  COOKIES_POLICY_FRAGMENT = 'cookies-policy-fragment',
  COOKIES_POLICY_ROUTE = 'cookies-policy-route',
  CREATE_NEW_USER_FRAGMENT = 'create-new-user-fragment',
  CREATE_NEW_USER_PRIVACY_FRAGMENT = 'create-new-user-privacy-fragment',
  CREATE_NEW_USER_PRIVACY_ROUTE = 'create-new-user-privacy-route',
  CREATE_NEW_USER_ROUTE = 'create-new-user-route',
  CREATE_NEW_USER_TERMS_FRAGMENT = 'create-new-user-terms-fragment',
  CREATE_NEW_USER_TERMS_ROUTE = 'create-new-user-terms-route',
  FORGET_PASSWORD_FRAGMENT = 'forget-password-fragment',
  FORGET_PASSWORD_REQUEST_SUCCESS = 'forget-password-request-success',
  FORGET_PASSWORD_REQUEST_SUCCESS_FRAGMENT = 'forget-password-request-success-fragment',
  FORGET_PASSWORD_ROUTE = 'forget-password-route',
  FORM_0 = 'form-0',
  FRAGMENT_AUTO_LOGOUT = 'fragment-auto-logout',
  FRAGMENT_LOGIN = 'fragment-login',
  HOME_FRAGMENT = 'home-fragment',
  HOME_ROUTE = 'home-route',
  LAYOUT_APP = 'layout-app',
  LOGIN_FRAGMENT = 'login-fragment',
  LOGIN_FRAGMENT1 = 'login-fragment1',
  LOGIN_PANEL = 'login-panel',
  LOGIN_ROUTE = 'login-route',
  LOGIN_ROUTE1 = 'login-route1',
  NATURAL_PERSON_LINK = 'natural-person-link',
  NATURAL_PERSON_LINK_SOLICITATION = 'natural-person-link-solicitation',
  PASSWORD_RESET_SUCCESS_FRAGMENT = 'password-reset-success-fragment',
  PASSWORD_RESET_SUCCESS_ROUTE = 'password-reset-success-route',
  PATIENT_ROOT = 'patient-root',
  PATIENTS_ROOT_ROUTE = 'patients-root-route',
  PREVIEW_ATTACHED_FILE_FRAGMENT = 'preview-attached-file-fragment',
  PREVIEW_ATTACHED_FILE_ROUTE = 'preview-attached-file-route',
  PROFILE_VERSION = 'profile-version',
  PUBLIC_SCHEDULING_ACTIONS = 'public-scheduling-actions',
  PUBLIC_SCHEDULING_ACTIONS_FRAGMENT = 'public-scheduling-actions-fragment',
  RESET_PASSWORD_FRAGMENT = 'reset-password-fragment',
  RESET_PASSWORD_ROUTE = 'reset-password-route',
  RESET_PASSWORD_TOKEN_FAILURE_FRAGMENT = 'reset-password-token-failure-fragment',
  RESET_PASSWORD_TOKEN_FAILURE_ROUTE = 'reset-password-token-failure-route',
  ROUTE_AUTO_LOGOUT = 'route-auto-logout',
  ROUTE_LOGIN = 'route-login',
  TEXT_COUNTER = 'text-counter',
  VERSION_FRAGMENT = 'version-fragment',
}
export { AppAliases };
